var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1715361928164,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1494,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M930.909091 139.636364H93.090909c-51.2 0-93.090909 41.890909-93.090909 93.090909v558.545454c0 51.2 41.890909 93.090909 93.090909 93.090909h837.818182c51.2 0 93.090909-41.890909 93.090909-93.090909v-558.545454c0-51.2-41.890909-93.090909-93.090909-93.090909z m-93.090909 651.636363H186.181818v-558.545454h651.636364v558.545454z",
    "p-id": 1495,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.cb507ed06c031bd6bc651b9a56f65ebc.svg";
export { ForwardRef as ReactComponent };